<gl-box #glBox>
  <div class="wrapper">
    <form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
      <div class="input-row input-row-name">
        <gl-input-container [glPremium]="true">
          <input data-ctx="input-name" formControlName="name" normal-input placeholder="name" type="text" />
        </gl-input-container>
      </div>
      <div class="input-row">
        @if (currentType === 0 || currentType === undefined || currentType === 2) {
          <gl-input-container
            [glPremium]="true"
            [units]="'length'"
            >
            <input
              data-ctx="input-length"
              [numericType]="'float'"
              formControlName="length"
              normal-input
              placeholder="length"
              type="text"
              />
          </gl-input-container>
        }
        @if (currentType === 0 || currentType === undefined) {
          <gl-input-container
            [glPremium]="true"
            [units]="'length'"
            >
            <input
              [numericType]="'float'"
              formControlName="width"
              normal-input
              placeholder="width"
              type="text"
              />
          </gl-input-container>
        }
        @if (currentType === 0 || currentType === undefined || currentType === 1) {
          <gl-input-container
            [glPremium]="true"
            [units]="'length'"
            >
            <input
              [numericType]="'float'"
              formControlName="height"
              normal-input
              placeholder="height"
              type="text"
              />
          </gl-input-container>
        }

        @if (currentType === 1 || currentType === 2) {
          <gl-input-container
            [units]="'length'"
            [glPremium]="true"
            >
            <input
              type="text"
              [numericType]="'float'"
              placeholder="diameter"
              normal-input
              formControlName="diameter"
              />
          </gl-input-container>
        }
      </div>
      <div class="input-row">
        <gl-input-container [units]="'weight'">
          <input
            [numericType]="'float'"
            formControlName="weight"
            normal-input
            placeholder="weight"
            type="text"
            />
        </gl-input-container>
        <gl-input-container>
          <input
            [numericType]="'float'"
            formControlName="quantity"
            min="1"
            number-input
            placeholder="quantity"
            type="number"
            />
        </gl-input-container>
        <gl-input-container [units]="'weight'">
          <input
            [numericType]="'float'"
            formControlName="sumOfWeights"
            normal-input
            placeholder="sum_of_weights"
            type="text"
            />
        </gl-input-container>
      </div>
      <div class="toggle-submit-row">
        <div class="save-checkbox">
          @if (checkboxActive) {
            <gl-icon-checkbox
              [checkboxFormGroup]="saveLoadForm"
              data-ctx="checkbox-remember"
              [tooltipInfo]="'save_info'"
              [controlName]="'remember'"
              [iconName]="'saveIcon'"
            ></gl-icon-checkbox>
          }
        </div>
        @if (isOutsideSpace && showAddToLoadingSpace()) {
          <div class="outsideContainer">
            <button outline-button class="outsideButton"
              (click)="loadLoadsOntoSpace($event)">{{ 'add_loads_to_loading_space' | translate }}
            </button>
            <div class="info" [glTooltip]="'load_loads_on_space_info'">i</div>
          </div>
        }
        <button data-ctx="button-submit" submit-button>{{ 'save' | translate }}</button>
      </div>
    </form>
    <div class="actions" data-ctx="container-actions">
      <button
        (click)="openColorPicker()"
        [glTooltip]="'choose_color'"
        [position]="'top'"
        outline-icon-button
        >
        <gl-icon [name]="'color-pallete'"></gl-icon>
      </button>
      @if (currentType === 1 || currentType === 2) {
        <gl-load-arrangement class="arrangementContainer" [stackingOptions]="stackingOptions"
          [isListEdit]="true"
          [currentType]="currentType"
        (loadArrangementChange)="loadArrangementChange($event)"></gl-load-arrangement>
      }
      @if (group.loadType !== 1) {
        <button
          (click)="rotate()"
          [glTooltip]="'rotate'"
          [position]="'top'"
          outline-icon-button
          >
          <gl-icon [name]="'rotate'"></gl-icon>
        </button>
      }
      @if (
        areGroupDimensionsSame() && !isPallet && group.loadType !== 1 && group.loadType !== 2
        ) {
        <button
          (click)="flip()"
          [glTooltip]="'flip_longer'"
          outline-icon-button
          >
          <gl-icon [name]="'flip'"></gl-icon>
        </button>
      }
      @if (
        !areGroupDimensionsSame() && !isPallet && group.loadType !== 1 && group.loadType !== 2
        ) {
        <button
          (click)="flipShorter()"
          [glTooltip]="'flip_shorter'"
          [position]="'top'"
          outline-icon-button
          >
          <gl-icon [name]="'flip-shorter'"></gl-icon>
        </button>
      }
      @if (
        !areGroupDimensionsSame() && !isPallet && group.loadType !== 1 && group.loadType !== 2
        ) {
        <button
          (click)="flipLonger()"
          [glTooltip]="'flip_longer'"
          [position]="'top'"
          outline-icon-button
          >
          <gl-icon [name]="'flip-longer'"></gl-icon>
        </button>
      }
      <button (click)="delete()" [glTooltip]="'delete'" [position]="'top'" outline-icon-button>
        <gl-icon [name]="'delete'"></gl-icon>
      </button>
    </div>
  </div>
  <gl-stacking
    [groupData]="group"
    [defaultOptions]="stackingOptions"
    (stackingOptions)="setStackingOptions($event)"
  ></gl-stacking>

  @if (colorPicker) {
    <gl-color-picker
      (closeColorPicker)="closeColorPicker()"
      (glMousedownOutside)="closeColorPicker()"
      (choosenColor)="changeColor($event)"
      >
    </gl-color-picker>
  }
</gl-box>
